import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as api from "../../services/api";
import "./DashboardHome.css";

export default function DashboardHome() {
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    totalProducts: 0,
    totalOrders: 0,
    totalCategories: 0,
    totalCoupons: 0,
    totalSales: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const [products, categories, coupons, orders] = await Promise.all([
        api.getProducts().catch(() => []),
        api.getCategories().catch(() => []),
        api.getAllCoupons().catch(() => []),
        api.getAllOrders().catch(() => [])
      ]);

      // Calculate total sales from all orders
      // Only count delivered orders or all orders (depending on business logic)
      // For now, counting all orders except cancelled/returned
      const validOrders = orders.filter(order => 
        order.status !== 'cancelled' && order.status !== 'returned'
      );
      const totalSales = validOrders.reduce((sum, order) => {
        return sum + (parseFloat(order.total) || 0);
      }, 0);

      setStats({
        totalProducts: products.length || 0,
        totalOrders: orders.length || 0,
        totalCategories: categories.length || 0,
        totalCoupons: coupons.length || 0,
        totalSales: totalSales
      });
    } catch (error) {
      console.error('Error loading stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="dashboard-home-loading">Loading dashboard...</div>;
  }

  return (
    <div className="dashboard-home">
      <div className="dashboard-header">
        <h1>Dashboard Overview</h1>
        <p>Welcome to AVRNHH Admin Panel</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card" onClick={() => navigate('/admin/products')}>
          <div className="stat-icon">📦</div>
          <div className="stat-content">
            <h3>{stats.totalProducts}</h3>
            <p>Total Products</p>
          </div>
        </div>

        <div className="stat-card" onClick={() => navigate('/admin/orders')}>
          <div className="stat-icon">🛒</div>
          <div className="stat-content">
            <h3>{stats.totalOrders}</h3>
            <p>Total Orders</p>
          </div>
        </div>

        <div className="stat-card" onClick={() => navigate('/admin/categories')}>
          <div className="stat-icon">📁</div>
          <div className="stat-content">
            <h3>{stats.totalCategories}</h3>
            <p>Categories</p>
          </div>
        </div>

        <div className="stat-card" onClick={() => navigate('/admin/coupons')}>
          <div className="stat-icon">🎟️</div>
          <div className="stat-content">
            <h3>{stats.totalCoupons}</h3>
            <p>Total Coupons</p>
          </div>
        </div>

        <div className="stat-card" onClick={() => navigate('/admin/orders')}>
          <div className="stat-icon">💰</div>
          <div className="stat-content">
            <h3>₹{stats.totalSales.toLocaleString('en-IN', { maximumFractionDigits: 0 })}</h3>
            <p>Total Sales</p>
          </div>
        </div>
      </div>

      <div className="quick-actions">
        <h2>Quick Actions</h2>
        <div className="actions-grid">
          <button 
            className="action-btn primary"
            onClick={() => navigate('/admin/products/new')}
          >
            ➕ Add New Product
          </button>
          <button 
            className="action-btn"
            onClick={() => navigate('/admin/categories')}
          >
            📁 Manage Categories
          </button>
          <button 
            className="action-btn"
            onClick={() => navigate('/admin/coupons')}
          >
            🎟️ Manage Coupons
          </button>
          <button 
            className="action-btn"
            onClick={() => navigate('/admin/orders')}
          >
            🛒 View Orders
          </button>
        </div>
      </div>
    </div>
  );
}

